import i18n from "@/i18n";
import type {TCountry, TInviteCategory, TTemplateForm} from "@/store/types";

export const AGENCY_ROUTES_WITHOUT_NAVIGATION = ["/campaigns/", "/influencers-list/"];

export const AWARDS_TO_HIDE = ["INSTAGRAM_VERIFIED", "TIKTOK_VERIFIED", "UGC_VERIFIED"];

export const CARD_BRANDS: Record<string, string> = {
  amex: require("@/assets/cards/amex.webp"),
  discover: require("@/assets/cards/discover.webp"),
  link: require("@/assets/cards/link.webp"),
  mastercard: require("@/assets/cards/mastercard.webp"),
  paypal: require("@/assets/cards/paypal.webp"),
  visa: require("@/assets/cards/visa.webp"),
} as const;

export const COUNTRIES = [
  "Switzerland",
  "Germany",
  "Austria",
  "France",
  "Italy",
  "Liechtenstein",
  "Luxembourg",
  "USA",
] as const;

export const COUNTRY_FILTERS: TCountry[] = ["Switzerland", "Germany", "Austria"];

export const FULL_DATE_FORMAT = "DD.MM.YYYY";

export const INFINITY_THRESHOLD = 1000;

export const OTHER_TEMPLATE_ID = 9999;

export const INITIAL_TEMPLATE_STATE: TTemplateForm = {
  id: OTHER_TEMPLATE_ID,
  name: i18n.t("Other"),
  translations: [
    {
      language_code: "de_CH",
      title: "",
      body: "",
    },
    {
      language_code: "en_EN",
      title: "",
      body: "",
    },
  ],
};

export const INVITE_CATEGORIES: TInviteCategory[] = [
  "ADMIN",
  "FAVORITE",
  "FOLLOWS_YOU",
  "GROUPS",
  "LIKED_YOU",
  "RECOMMENDED",
  "WORKED_WITH",
] as const;

export const LANGUAGE_OPTIONS = [
  {code: "de_CH", i18nextCode: "ger", name: "german"},
  {code: "en_EN", i18nextCode: "en", name: "english"},
] as const;

export const LEARN_ABOUT_US_OPTIONS = [
  "GoogleAds",
  "LinkedinAds",
  "ContactedByUs",
  "DragonsDen",
  "Media",
  "ETH",
  "DMEXCO",
  "OMR",
  "RecommendationFromAnotherCompany",
  "RecommendationFromInfluencer",
  "Agency",
  "Other",
] as const;

export const LINKS = {
  androidApp: "https://play.google.com/store/apps/details?id=ch.refluenced.app",
  iosApp: "https://apps.apple.com/ch/app/refluenced/id1642307723",
} as const;

export const PERMISSIONS = [
  "REFLUENCED_COMPANY_ADMIN",
  "REFLUENCED_INFLUENCER_ADMIN",
  "ADMIN",
  "WRITE",
  "PURCHASE",
  "READ",
] as const;

export const VIDEO_EXTENSIONS = ["mov", "mp4"];
